import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown, HelpCircle } from "lucide-react";
import {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
} from "../ui/accordion";
import { FAQS } from "../../lib/site-data";

export const FAQ = () => {
    const [open, setOpen] = useState(false);

    return (
        <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 bg-brand-cream">
            <div className="max-w-3xl mx-auto px-6 sm:px-8">
                <motion.button
                    onClick={() => setOpen(!open)}
                    data-testid="faq-toggle"
                    className="w-full flex items-center justify-between gap-6 rounded-3xl glass border border-brand-border px-7 py-6 hover:border-brand-coral transition-all group"
                    whileHover={{ y: -2 }}
                >
                    <div className="flex items-center gap-4 text-left">
                        <span className="h-11 w-11 rounded-full bg-brand-coral/10 flex items-center justify-center shrink-0 group-hover:bg-brand-coral/20 transition-colors">
                            <HelpCircle className="h-5 w-5 text-brand-coral" strokeWidth={1.6} />
                        </span>
                        <div>
                            <p className="text-xs tracking-[0.25em] uppercase text-brand-coral mb-1">FAQ</p>
                            <h3 className="font-display text-2xl sm:text-3xl text-brand-ink leading-tight">
                                Got questions? We have answers.
                            </h3>
                        </div>
                    </div>
                    <ChevronDown
                        className={`h-6 w-6 text-brand-ink transition-transform duration-500 shrink-0 ${
                            open ? "rotate-180" : ""
                        }`}
                    />
                </motion.button>

                <motion.div
                    initial={false}
                    animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0, marginTop: open ? 24 : 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    style={{ overflow: "hidden" }}
                >
                    <div className="bg-white rounded-3xl border border-brand-border p-2 sm:p-4">
                        <Accordion type="single" collapsible className="w-full">
                            {FAQS.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className="border-b last:border-0 border-brand-border/70"
                                >
                                    <AccordionTrigger
                                        data-testid={`faq-trigger-${i}`}
                                        className="text-left text-base sm:text-lg font-display text-brand-ink py-5 px-3 hover:no-underline hover:text-brand-coral"
                                    >
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-brand-inkSoft text-[15px] leading-relaxed px-3 pb-5">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default FAQ;
